function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M128.25,197.31A24.68,24.68,0,0,0,105,213.77H50.23A8.23,8.23,0,0,0,42,222h0a8.23,8.23,0,0,0,8.23,8.23H105a24.66,24.66,0,0,0,46.51,0h98.26A8.23,8.23,0,0,0,258,222h0a8.23,8.23,0,0,0-8.23-8.23H151.51A24.69,24.69,0,0,0,128.25,197.31Zm0,33a8.33,8.33,0,1,1,8.34-8.33A8.33,8.33,0,0,1,128.25,230.33Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M83.25,53.31A24.68,24.68,0,0,0,60,69.77H50.23A8.23,8.23,0,0,0,42,78h0a8.23,8.23,0,0,0,8.23,8.23H60a24.66,24.66,0,0,0,46.51,0H249.77A8.23,8.23,0,0,0,258,78h0a8.23,8.23,0,0,0-8.23-8.23H106.51A24.69,24.69,0,0,0,83.25,53.31Zm0,33A8.33,8.33,0,1,1,91.59,78,8.33,8.33,0,0,1,83.25,86.33Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M192.19,125.06a24.69,24.69,0,0,0-23.26,16.46H50.23A8.23,8.23,0,0,0,42,149.75h0A8.22,8.22,0,0,0,50.23,158h118.7a24.66,24.66,0,0,0,46.51,0h34.33a8.22,8.22,0,0,0,8.23-8.23h0a8.23,8.23,0,0,0-8.23-8.23H215.44A24.68,24.68,0,0,0,192.19,125.06Zm0,33a8.33,8.33,0,1,1,8.33-8.33A8.34,8.34,0,0,1,192.19,158.08Z"
});

var SvgExperiment = function SvgExperiment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExperiment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/experiment.846384c0.svg";
export { ForwardRef as ReactComponent };